import React from "react";
import styles from "./parts.module.css";

export const BoxItemAssignedShelfNumber = ({
  shelf,
  quantity,
}: {
  shelf: string;
  quantity: number;
}) => (
  <div className={styles["progress-container"]}>
    <div className={styles["progress-bar"]}>
      <p className={styles["shelf-part"]}>{shelf}</p>
    </div>
    <span className={styles["progress-text"]}>{quantity}</span>
  </div>
);
